import { useLocalStoreWithDep } from "designSystem/hooks";
import React, { FunctionComponent } from "react";
import { SingleSelectComponent } from "../index";
import { useGoToDialogSave } from "../select/hooks";
import { RefStore } from "./RefStore";
import { RefProps } from "./RefStoreBase";
import { observer } from "mobx-react-lite";

export const Ref: FunctionComponent<RefProps> = observer(({ attributeId, nodeType, nodeUrl, reportOperations }) => {
	const refStore = useLocalStoreWithDep(() => new RefStore(attributeId, nodeType, nodeUrl, reportOperations), [reportOperations]);
	const { store } = refStore || {};
	const goToDialogSave = useGoToDialogSave();

	return (
		<SingleSelectComponent aggregateStore={store} goToDialogSave={goToDialogSave} />
	);
});
